import { render, staticRenderFns } from "./VSelectVacunaBySede.vue?vue&type=template&id=1722cfc0&scoped=true&"
import script from "./VSelectVacunaBySede.vue?vue&type=script&lang=js&"
export * from "./VSelectVacunaBySede.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1722cfc0",
  null
  
)

export default component.exports